import { render, staticRenderFns } from "./AdminActionsCard.htm?vue&type=template&id=b978fdae&scoped=true&"
import script from "./AdminActionsCard.ts?vue&type=script&lang=js&"
export * from "./AdminActionsCard.ts?vue&type=script&lang=js&"
import style0 from "./AdminActionsCard.scss?vue&type=style&index=0&id=b978fdae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b978fdae",
  null
  
)

export default component.exports